import { isServer } from "shared/constants/isServer"
import { Bundle } from "../TopUpBalance/BundleItem"
import { OrderInitial } from "../../constants/types"
import { FlowType } from "../../constants/flowType"
import { EntityPaymentTypes } from "../../constants/payment"
import economicUrlApi from "../../helpers/economicUrlApi"
import { OrderStatuses } from "../CheckOut/types"
import { sleep } from "../../helpers/sleep"
import { Dispatch } from "react"

interface BuyBundleHandler {
    bundle: Bundle
    contextName?: string
    close?: () => void
    error: (message: string) => unknown
    isBuying: boolean
    order?: OrderInitial
    profileId?: string
    setIsBuying: Dispatch<any>
    t: any
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
    modal?: any
}

interface GetPaymentCallbacks { 
    contextName?: string
    order?: OrderInitial & { productId?: string }
    competitionId?: string
    selectedProjectId?: string
}

/**
 * формирует адреса, по которым будет перенаправлен пользователь, 
 * после успешной или ошибочной операции в системе платжей (сначала система платежей редиректит в наш сервис платежей, а он редиректит по этим колбекам)
 */
export const getPaymentCallbacks = (props: GetPaymentCallbacks) => {
    if (isServer) {
        return { checkoutUrlSuccess: '', checkoutUrlError: '' }
    }
    const { order, competitionId, selectedProjectId } = props || {}
    const origin = window.location.origin
    let redirectId = ''
    let redirectType =  ''
    let checkoutUrlSuccess = `${origin}/payment/success`
    let checkoutUrlError = `${origin}/payment/error`
    
    if(!order) {
        checkoutUrlSuccess += `/${redirectType}/${redirectId}?status=done`
        checkoutUrlError += `/${redirectType}/${redirectId}?status=failure`
        return {
            checkoutUrlSuccess,
            checkoutUrlError,
        }
    }

    redirectType = order?.flowType || order.flowType || FlowType.TOPUP_BALANCE
    redirectId = order?.productId || order?.immediatePurchaseProps?.productId ||  order?.orderId ||
        (order?.products?.length && order.products[0].productId) || ''

    // Для COPY_CARD flow возвращаем в исходный модуль проекта
    if (order?.flowType === FlowType.COPY_CARD && competitionId) {
        const projectParam = selectedProjectId ? `&selectedProjectId=${selectedProjectId}` : '';
        checkoutUrlSuccess += `/${redirectType}/${redirectId}?competitionId=${competitionId}${projectParam}&status=done`;
        checkoutUrlError += `/${redirectType}/${redirectId}?competitionId=${competitionId}${projectParam}&status=failure`;
    } else {
        checkoutUrlSuccess += `/${redirectType}/${redirectId}?status=done`;
        checkoutUrlError += `/${redirectType}/${redirectId}?status=failure`;
    }
    const origType = order?.immediatePurchaseProps?.flowType || order?.flowType;

    if (origType && redirectType === FlowType.TOPUP_BALANCE) {
        checkoutUrlSuccess += `&source=${origType}`;
        checkoutUrlError += `&source=${origType}`;
    }

    if (order?.flowType === FlowType.TOPUP_BALANCE || order?.immediatePurchaseProps?.flowType === FlowType.TOPUP_BALANCE) {
        const url = new URL(window.location.href);
        url.searchParams.delete("orderId");
        url.searchParams.delete("source");
        url.searchParams.append("source", origType);
        
        checkoutUrlSuccess = url.toString();;
        checkoutUrlError = url.toString();;
    }

    return {
        checkoutUrlSuccess,
        checkoutUrlError,
    }
}

/**
 * обработчик покупки бандла (пополнения счета)
 */
export const buyBundleHandler = async (props: BuyBundleHandler) => {
    const { isBuying, profileId, close, error, t, bundle, setIsBuying, modal, competitionId, selectedProjectId  } = props
    if (isServer) {
        return
    }
    const { buyFor } = bundle || {}

    if (isBuying) return
    if (!profileId) {
        error(t('card_constructor.info_panel.error_not_login'))
        close && close()
        return
    }
    if (!bundle?.id) {
        error(t('unable to topup your balance'))
        close && close()
        return
    }
    setIsBuying(() => true)
    try {
        const { checkoutUrlError, checkoutUrlSuccess } = getPaymentCallbacks({ order: props.order, competitionId, selectedProjectId })

        // Формируем totalPrice из выбранного бандла
        const totalPrice = {
            parts: [
                {
                    currencyType: buyFor.currencyType,
                    amount: buyFor.amount
                }
            ]
        };


        const purchaseRequest = await economicUrlApi().createAndPurchaseOrder(
            bundle?.id,
            buyFor.currencyType,
            {
                paymentEntityType: EntityPaymentTypes.bundle,
                totalPrice: totalPrice,
                options: { checkoutUrlSuccess, checkoutUrlError }
            },
        ) as any;
        if (purchaseRequest?.ErrorStatusCode >= 400) {
            console.error('buyBundle err:');
            error(t('unable to topup your balance'))
            setIsBuying(() => false)
            close && close()
            return
        }
        const { id: orderId } = purchaseRequest || {}
        for (let i = 0; i <= 10; i++) {
            const orderRequest = await economicUrlApi().getOrder(orderId as string) as any;
            if (orderRequest.orderStatusType === OrderStatuses.failedRejected) {
                error(t('unable to topup your balance'))
                setIsBuying(() => false)
                close && close()
                return
            }
            if (orderRequest.orderStatusType === OrderStatuses.awaitingAcquiringPayment) {
                window.location.href = orderRequest.acquiringUrl
                break
            }
            await sleep(1000)
        }
    } catch (err: any) {
        modal?.show('paymentUnavailable')
        // error(t(err.message))
        console.error('buyBundle err:', err);

    } finally {
        setIsBuying(() => false)
    }
}import { isServer } from "shared/constants/isServer"
import { Bundle } from "../TopUpBalance/BundleItem"
import { OrderInitial } from "../../constants/types"
import { FlowType } from "../../constants/flowType"
import { EntityPaymentTypes } from "../../constants/payment"
import economicUrlApi from "../../helpers/economicUrlApi"
import { OrderStatuses } from "../CheckOut/types"
import { sleep } from "../../helpers/sleep"
import { Dispatch } from "react"

interface BuyBundleHandler {
    bundle: Bundle
    contextName?: string
    close?: () => void
    error: (message: string) => unknown
    isBuying: boolean
    order?: OrderInitial
    profileId?: string
    setIsBuying: Dispatch<any>
    t: any
    competitionId?: string // ID конкурса для COPY_CARD flow
    selectedProjectId?: string // ID выбранного проекта для COPY_CARD flow
    modal?: any
}

interface GetPaymentCallbacks { 
    contextName?: string
    order?: OrderInitial & { productId?: string }
    competitionId?: string
    selectedProjectId?: string
}

/**
 * формирует адреса, по которым будет перенаправлен пользователь, 
 * после успешной или ошибочной операции в системе платжей (сначала система платежей редиректит в наш сервис платежей, а он редиректит по этим колбекам)
 */
export const getPaymentCallbacks = (props: GetPaymentCallbacks) => {
    if (isServer) {
        return { checkoutUrlSuccess: '', checkoutUrlError: '' }
    }
    const { order, competitionId, selectedProjectId } = props || {}
    const origin = window.location.origin
    let redirectId = ''
    let redirectType =  ''
    let checkoutUrlSuccess = `${origin}/payment/success`
    let checkoutUrlError = `${origin}/payment/error`
    
    if(!order) {
        checkoutUrlSuccess += `/${redirectType}/${redirectId}?status=done`
        checkoutUrlError += `/${redirectType}/${redirectId}?status=failure`
        return {
            checkoutUrlSuccess,
            checkoutUrlError,
        }
    }

    redirectType = order?.flowType || order.flowType || FlowType.TOPUP_BALANCE
    redirectId = order?.productId || order?.immediatePurchaseProps?.productId ||  order?.orderId ||
        (order?.products?.length && order.products[0].productId) || ''

    // Для COPY_CARD flow возвращаем в исходный модуль проекта
    if (order?.flowType === FlowType.COPY_CARD && competitionId) {
        const projectParam = selectedProjectId ? `&selectedProjectId=${selectedProjectId}` : '';
        checkoutUrlSuccess += `/${redirectType}/${redirectId}?competitionId=${competitionId}${projectParam}&status=done`;
        checkoutUrlError += `/${redirectType}/${redirectId}?competitionId=${competitionId}${projectParam}&status=failure`;
    } else {
        checkoutUrlSuccess += `/${redirectType}/${redirectId}?status=done`;
        checkoutUrlError += `/${redirectType}/${redirectId}?status=failure`;
    }
    const origType = order?.immediatePurchaseProps?.flowType || order?.flowType;

    if (origType && redirectType === FlowType.TOPUP_BALANCE) {
        checkoutUrlSuccess += `&source=${origType}`;
        checkoutUrlError += `&source=${origType}`;
    }

    if (order?.flowType === FlowType.TOPUP_BALANCE || order?.immediatePurchaseProps?.flowType === FlowType.TOPUP_BALANCE) {
        const url = new URL(window.location.href);
        url.searchParams.delete("orderId");
        url.searchParams.delete("source");
        url.searchParams.append("source", origType);
        
        checkoutUrlSuccess = url.toString();;
        checkoutUrlError = url.toString();;
    }

    return {
        checkoutUrlSuccess,
        checkoutUrlError,
    }
}

/**
 * обработчик покупки бандла (пополнения счета)
 */
export const buyBundleHandler = async (props: BuyBundleHandler) => {
    const { isBuying, profileId, close, error, t, bundle, setIsBuying, modal, competitionId, selectedProjectId  } = props
    if (isServer) {
        return
    }
    const { buyFor } = bundle || {}

    if (isBuying) return
    if (!profileId) {
        error(t('card_constructor.info_panel.error_not_login'))
        close && close()
        return
    }
    if (!bundle?.id) {
        error(t('unable to topup your balance'))
        close && close()
        return
    }
    setIsBuying(() => true)
    try {
        const { checkoutUrlError, checkoutUrlSuccess } = getPaymentCallbacks({ order: props.order, competitionId, selectedProjectId })

        // Формируем totalPrice из выбранного бандла
        const totalPrice = {
            parts: [
                {
                    currencyType: buyFor.currencyType,
                    amount: buyFor.amount
                }
            ]
        };


        const purchaseRequest = await economicUrlApi().createAndPurchaseOrder(
            bundle?.id,
            buyFor.currencyType,
            {
                paymentEntityType: EntityPaymentTypes.bundle,
                totalPrice: totalPrice,
                options: { checkoutUrlSuccess, checkoutUrlError }
            },
        ) as any;
        if (purchaseRequest?.ErrorStatusCode >= 400) {
            console.error('buyBundle err:');
            error(t('unable to topup your balance'))
            setIsBuying(() => false)
            close && close()
            return
        }
        const { id: orderId } = purchaseRequest || {}
        for (let i = 0; i <= 10; i++) {
            const orderRequest = await economicUrlApi().getOrder(orderId as string) as any;
            if (orderRequest.orderStatusType === OrderStatuses.failedRejected) {
                error(t('unable to topup your balance'))
                setIsBuying(() => false)
                close && close()
                return
            }
            if (orderRequest.orderStatusType === OrderStatuses.awaitingAcquiringPayment) {
                window.location.href = orderRequest.acquiringUrl
                break
            }
            await sleep(1000)
        }
    } catch (err: any) {
        modal?.show('paymentUnavailable')
        // error(t(err.message))
        console.error('buyBundle err:', err);

    } finally {
        setIsBuying(() => false)
    }
}